import { render, staticRenderFns } from "./DisapprovalForm.vue?vue&type=template&id=3df20d91"
import script from "./DisapprovalForm.vue?vue&type=script&lang=js"
export * from "./DisapprovalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports